/* src/app/import-table-maker/table-view-popup/table-view-popup.component.css */
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
tr:nth-child(even) {
  background-color: #dddddd;
}
#container {
  position: relative;
  top: 0px;
  right: 0px;
  overflow: visible;
}
.remove-column {
  color: white;
  top: 0px;
  right: 0px;
  color: grey;
  cursor: pointer;
}
tr td {
  white-space: nowrap;
  margin: 2px;
}
::ng-deep app-table-view-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
mat-chip {
  padding-left: 10px;
  padding-right: 10px;
}
.top-bar-buttons {
  float: right;
  cursor: pointer;
  right: 0 !important;
  top: 0 !important;
}
.top-bar-button {
  margin-left: 15px;
}
.title {
  float: left;
}
.custom-file-upload {
  margin-top: 8px;
  margin-left: 10px;
}
input[type=file] {
  display: none;
}
.selection-file {
  display: inline-block;
}
.selection-file-container {
  text-align: center;
}
.file {
  cursor: pointer;
  color: var(--primary-color);
}
.fx-spacer {
  flex: 1 1 auto;
}
/*# sourceMappingURL=table-view-popup.component.css.map */
